import { AppShell } from '../shared/ui/AppShell'

type PlaceholderPageProps = {
  title: string
  description?: string
}

export function PlaceholderPage({ title, description }: PlaceholderPageProps) {
  const showAnalytics = true

  return (
    <AppShell showAnalytics={showAnalytics} showTopBar>
      <div
        style={{
          maxWidth: 680,
          margin: '0 auto',
          width: '100%',
          padding: 'var(--spacing-xl)',
        }}
      >
        <h1
          style={{
            margin: 0,
            fontSize: 22,
            fontWeight: 600,
            color: 'var(--text)',
          }}
        >
          {title}
        </h1>
        <p
          style={{
            margin: 'var(--spacing-md) 0 0',
            fontSize: 15,
            color: 'var(--text-muted)',
          }}
        >
          {description ?? 'Coming soon.'}
        </p>
      </div>
    </AppShell>
  )
}
